import React from 'react';
import {Dialog} from '@material-ui/core';
import styles from './NxPopup.scss';
import clsx from 'clsx';


export interface NxPopupProps {
  children: React.ReactNode;
  description?: React.ReactNode;
  header: React.ReactNode;
  open: boolean;
  onClose?: () => void;
}

const NxPopup = ({children, description, header, open, onClose}: NxPopupProps): React.ReactElement => {

  const childrenCount = React.Children.count(children);

  const rowClassNames = clsx(
    styles.row,
    {
      [styles['row_single']]: childrenCount === 1,
      [styles['row_multiple']]: childrenCount > 1
    });

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={styles.popup}>
        <div className={styles.header}>{header}</div>
        {description && <div className={styles.description}>{description}</div>}
        <div className={rowClassNames}>
          {children}
        </div>
      </div>
    </Dialog>
  );
};

export default NxPopup;